import parcelshopSearchUrlList from '../static/parcelshopUrls.json';
export const DEFAULT_PARCELSHOP_URL = "https://gls-group.eu/GROUP/en/gls-parcelshop-lockers-search";


export function getCountrySpecificUrl(countryCode) {

  let country = parcelshopSearchUrlList.find(e => e.country === countryCode);
  let url = country ? country.url : DEFAULT_PARCELSHOP_URL;
  return url
}

export function countryHasURL(countryCode) {

  if (parcelshopSearchUrlList.find(e => e.country === countryCode)) {
    return true;
  }
    return false;
}



// WEBPACK FOOTER //
// ./static/parcelshopSearchURLs.js